import React from 'react';
import { usePage } from "@inertiajs/react";
import { reduce } from "lodash";
import SelectMulti from "@/User/Components/SelectMulti";

const BudgetSelect = ({ id, values, handleChange }) => {
    const { budgetList } = usePage().props;

    const budgetOptions = reduce(budgetList, (result, budget, idx) => {
        return {
            ...result,
            [idx]: budget.label,
        };
    }, {});

    return (
        <SelectMulti id={id} options={budgetOptions} value={values} handleChange={handleChange} placeholder="予算を選ぶ" />
    );
};

export default BudgetSelect;
